<div aria-live="polite" aria-atomic="true" class="position-relative">
  <div
    class="toast-container position-fixed bottom-0 end-0 p-3"
    style="z-index: 1100"
  >
    @for (toast of toasts; track $index) {
    <div
      @fadeIn
      @fadeOut
      class="toast align-items-center text-bg-{{ toast.type }} border-0 show"
      role="alert"
    >
      <div class="d-flex">
        <div class="toast-body">

          @switch (toast.type) { 
            @case ('success') {
            <i class="fa-solid fa-circle-check me-1"></i>
            } @case ('danger') {
            <i class="fa-solid fa-circle-xmark me-1"></i>
            } @case ('warning') {
            <i class="fa-solid fa-circle-exclamation me-1"></i>
            } @default {
            <i class="fa-solid fa-circle-info me-1"></i>
            } 
          }
          {{ toast.message }}
          
        </div>
        <button
          type="button"
          class="btn-close btn-close-white me-2 m-auto"
          (click)="remove(toast)"
        ></button>
      </div>
    </div>
    }
  </div>
</div>
